import {
    createStore
} from 'vuex'
import authModule from './modules/auth'
import userModule from './modules/user'
import appModule from './modules/app'
import miaAziendaModule from './modules/miaAzienda'
import aziendeModule from './modules/aziende'
import commesseModule from './modules/commesse'
import tipologieModule from './modules/tipologie'
import tipiDisegnoModule from './modules/tipiDisegno'
import apertureModule from './modules/aperture'
import progettiModule from './modules/progetti'

export default createStore({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        auth: authModule,
        user: userModule,
        app: appModule,
        miaAzienda: miaAziendaModule,
        aziende: aziendeModule,
        commesse: commesseModule,
        tipologie: tipologieModule,
        tipiDisegno: tipiDisegnoModule,
        aperture: apertureModule,
        progetti: progettiModule,
    }
})
